module.exports = __webpack_public_path__ + "media/theme/steps--4--close-4302dea8.png";